module.exports = __webpack_public_path__ + "media/2022/matching-algorithm-c3365f3e.png";